<template>
    <div id="addview">
      <div class="mainHead">
        <div class="route">
          <span class="crumbs"></span><span class="link" @click="returnBtn">监测点管理</span><span class="arrow">></span><span>3D配置项设置</span>
        </div>
        <div> 
          <el-button type="primary" @click="returnBtn">返回</el-button>
        </div>
      </div>
      <div class="fixedScorll" :style="{height: heightCard + 'px'}">
        <div class="maindetails" :style="{height: heightBg + 'px'}">
            <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm" >
                <el-form-item label="监测点名称:"   style="display: inline-block;" :show-message="false">
                    <el-select v-model="ruleForm.enabled">
                        <el-option :label="item.monitoringThingjsId" :value="item.monitoringThingjsId" v-for="(item,index) in getName" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="IMEI码:"  style="display: inline-block;"  :show-message="false">
                    <el-select v-model="ruleForm.enabled1">
                        <el-option :label="item.label" :value="item.id" v-for="(item,index) in restaurants" :key="index"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item >
                    <el-button style="margin-top:80px;" type="primary" @click="submitForm()">保存</el-button>
                </el-form-item>

            </el-form>
        </div>
      </div>
   
    <!-- 提示框(自动消失) -->
    <el-dialog title="提示" class="tips" :visible.sync="dialogTipsVisible" :modal="false" :closeOnClickModal="false">
        <span>{{tips}}</span>
        <span slot="footer" class="dialog-footer">
            <el-button style="min-width:80px" type="primary" @click="dialogTipsVisible = false">我知道了</el-button>
        </span>
    </el-dialog>
    <!-- 确认提示框 -->
    <el-dialog title="提示" class="tipsTwo" :visible.sync="dialogTipsSureVisible" :modal-append-to-body="false">
        <div>确认提交所选配置？</div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogTipsSureVisible = false">取 消</el-button>
            <el-button type="primary" @click="TipsSure(sureType)">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
    import {ajaxFuncJson} from '@/api/ajax';
    export default {
        name: 'addView',
        props:['infoId'],
        data() {
            return {
                heightCard:'',
                heightBg:'',
                activeIndex:"'4-1'", //Top导航选中值
                ruleForm: { //表单提交数据
                    enabled: '', //名字
                    enabled1: '', //IMEI码
                },
                dialogTipsVisible:false, //自动消失提示
                dialogTipsSureVisible:false, //确认提示
                tips:'信息填写不完善，请完善信息！', //提示语
                windowResize:null,
                maryKey:'',//提交所用数据
                getName:[],//监测点名称
                restaurants:[],//IMEI
                newSave:[],//提交所用
            }
        },
        watch: {

        },
        created() {
          this.getDeviceName();//监测点名称
          this.selectByPrimaryKey();//提交所需要数据
          this.checkDeviceList();//IMEI码
        },
        methods: {
          isScroll(){
            this.$nextTick(()=>{
              let sHeight=document.getElementsByClassName('fixedScorll')[0].scrollHeight,
                cHeight=document.getElementsByClassName('fixedScorll')[0].clientHeight;
              if(sHeight>cHeight){
                document.getElementsByClassName('maindetails')[0].style.marginRight=0;
              }else {
                document.getElementsByClassName('maindetails')[0].style.marginRight='1.05%';
              }
            });
          },
          openhint(obj,obj1) {
            if(obj1==1){
              this.$message.error(obj);
            }else if(obj1==2){
              this.$message({
                message: obj,
                type: 'success'
              });
            }
            
          },
          // 返回监测点管理
          returnBtn(){
             this.$router.push({path:'/content/BasicData'}); //监测点首页
          },
          // 点击保存
          submitForm(){
            if(!this.ruleForm.enabled){
              this.openhint('监测点名称不可为空',1);
              return;
            }
            if(!this.ruleForm.enabled1){
              this.openhint('IMEI码不可为空',1);
              return;
            }
            this.restaurants.forEach((item,index)=>{
              if(this.ruleForm.enabled1==item.id){
                this.newSave.push(item)
              }
            })
            this.creatThingjsMonitor()
          },

          // 获取thingjs的监测点名
          getDeviceName(){ //确认提示
            let parms={
               
            }
            ajaxFuncJson('/thingjs/getDeviceName',parms).then(res=>{
                if(res.data.status == 200){
                   this.getName = res.data.data;

                }else{
                  this.openhint('接口错误',1);
                }
            })
          },
          // 提交所需要用的东西
          selectByPrimaryKey(){ //获取安装地址(查看建筑详情)
            let parms = {
                  buildingId: sessionStorage.getItem("buildingId"),
                }
              ajaxFuncJson('/basicData/selectByPrimaryKey',parms).then(res=>{
                  if(res.data.status == 200){
                      this.maryKey = res.data.data;
                  }
              })
          },
          // IMEI码
          checkDeviceList(){
            ajaxFuncJson('/monitoring/checkDeviceList',{type:''}).then(res=>{
              if(res.data.status == 200){
                  if(res.data.data.length>0){
                    res.data.data.forEach((item,index)=>{
                      item.label =item.typeName +'----'+ item.devicename +'----'+ item.deviceimei;
                    })
                    this.restaurants = res.data.data; //赋值搜索值

                  }else{
                    this.restaurants = []; //赋值搜索值
                  }
                  
              }else{
                this.openhint('接口错误',1);
              }
            })
          },
           // 新建3d监测点
          creatThingjsMonitor(){ //确认提示
            let parms={
              buildingId: this.maryKey.id,
              customerId:  this.maryKey.customerId,
              detailAddress: this.maryKey.detailAddress,
              deviceIMEI: this.newSave[0].deviceimei,
              deviceId: this.newSave[0].id,
              enabled: false,
              installAddress: this.maryKey.address,
              linkTxt: "",
              monitoringCode: this.newSave[0].deviceimei.substr(-4),
              monitoringName: this.ruleForm.enabled,
              remark: "",
              type: this.newSave[0].type,
            }
            ajaxFuncJson('/thingjs/creatThingjsMonitor',parms).then(res=>{
                if(res.data.status == 200){ 
                  this.ruleForm.enabled1 = '';
                  this.ruleForm.enabled = '';
                  this.getDeviceName();//监测点名称
                  this.checkDeviceList();//IMEI码
                  this.openhint('绑定成功',2);
                }else{
                  this.openhint('接口错误',1);
                }
            })
          },


        },
        mounted() {
            let that = this;
            that.windowResize= function () {
                that.heightCard = $(document.body).height() - $('.el-header').outerHeight(true)- $('.mainHead').outerHeight(true) -20;
                that.heightBg =  that.heightCard;
                that.isScroll();
            };
            that.windowResize();
            window.addEventListener('resize',that.windowResize);
        },
        destroyed(){
          let _this=this;
          window.removeEventListener("resize",_this.windowResize)
        }
    }
</script>

<style scoped lang="scss">
@import "@/assets/css/mixin.scss";
// 内容布局
.el-main{
  width: 78.1%;
  margin:10px 0 7px 1.05%;
  padding: 0;
  .maindetails{
      min-height: 800px;
      padding: 40px 0;
      padding-left: 70px;
      margin-right: 1.05%;
      background-color:#fff;
  }
}

.txtcolor span{
    color: #282828;
}
.el-input{
  width:130px !important;
}


</style>



// WEBPACK FOOTER //
// src/page/BasicData/addView.vue